import React from "react";
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
} from "@material-ui/core";
import { Button } from "../../../../components/Wrappers";

import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
  },
  table: {
    minWidth: 700,
  },
});

function TableComponent(props) {
  let {
    data,
    offset,
    classes,
    handleOpenViewCreateModal
  } = props;


  return (
    <Paper className={classes.root} style={{ width: "90" }}>
      <Table className={classes.table}>
        <Table className="mb-0">
          <TableHead style={{ background: "#f6f6f6" }}>
            <TableRow>
              <TableCell>S. NO.</TableCell>
              <TableCell>Job Details</TableCell>
              <TableCell>Job Title</TableCell>
              {/* <TableCell>Landlord</TableCell> */}
              {/* <TableCell>Email</TableCell> */}
              <TableCell>Address</TableCell>
              <TableCell>Designation</TableCell>
              <TableCell style={{ whiteSpace: "nowrap" }}>Job Type</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((tempdata, index) => (
              <TableRow key={index}>
                <TableCell className="pl-3 fw-normal">
                  {offset + index + 1}
                </TableCell>
                <TableCell className="pl-3 fw-normal">
                  {tempdata.job_details}
                </TableCell>
                <TableCell className="pl-3 fw-normal">
                  {tempdata.job_title}
                </TableCell>
                {/* <TableCell className="pl-3 fw-normal">
                  {getEmail(tempdata)}
                </TableCell> */}
                {/* <TableCell className="pl-3 fw-normal">
                  {tempdata.location_id
                    ? `${tempdata.location_id.line1} ${tempdata.location_id.line2} ${tempdata.location_id.line3}`
                    : ""}
                  {tempdata.location_id && tempdata.location_id.city
                    ? tempdata.location_id.city
                    : "-"}
                  {tempdata.location_id && tempdata.location_id.line1
                    ? tempdata.location_id.line1
                    : "-"}
                  {tempdata.location_id && tempdata.location_id.line2
                    ? tempdata.location_id.line2
                    : "-"}
                  {tempdata.location_id && tempdata.location_id.line3
                    ? tempdata.location_id.line3
                    : "-"}
                </TableCell> */}
                <TableCell className="pl-3 fw-normal">
                  {tempdata && tempdata.location_id
                    ? tempdata.location_id.linecomplete
                    : "-"}
                </TableCell>
                <TableCell className="pl-3 fw-normal">
                  {tempdata.designation_Id && tempdata.designation_Id.name
                    ? tempdata.designation_Id.name
                    : "-"}
                </TableCell>
                <TableCell className="pl-3 fw-normal">
                  {tempdata.jobType_Id && tempdata.jobType_Id.name
                    ? tempdata.jobType_Id.name
                    : "-"}
                </TableCell>
                <TableCell style={{ textAlign: "center" }}>
                  <Button
                    color="success"
                    size="small"
                    className="px-2"
                    variant="contained"
                    style={{ marginRight: "5px" }}
                    onClick={() => handleOpenViewCreateModal(tempdata)}
                  >
                    More Details
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Table>
    </Paper>
  );
}

export default withStyles(styles)(TableComponent);
